import { AloftPrice, orUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectManualAdjustmentsEntities } from '../propertyDataSelectors/manualAdjustmentsSelectors.ts';

export const selectOtherAdjustments = createSelector(
  [selectManualAdjustmentsEntities],
  (manualAdjustmentsEntities) =>
    Object.fromEntries(
      Object.entries(manualAdjustmentsEntities).map(([id, manualAdjustments]) => [
        id,
        orUndefined(AloftPrice.schema.parse)(manualAdjustments.other),
      ]),
    ),
);
